<div class="ps-2 pe-2">
  <h1 mat-dialog-title i18n>Error</h1>
  <div mat-dialog-content>
    <p>{{data.error}}</p>
  </div>
  <div mat-dialog-actions class="w-100">
    <button class="w-100" mat-button (click)="onCloseClick()" i18n>OK</button>
  </div>
</div>
